<template>
  <div>
    <v-container fluid class="pa-0">
      <!-- <v-row>
        <v-tabs class="d-flex justify-center">
          <v-tab v-for="ruta in rutas" :key="ruta.name" link :to="{name:ruta.name}" router exact>{{ruta.tittle}}</v-tab>
        </v-tabs>
      </v-row> -->
      <v-row class="pa-0">
        <router-view></router-view>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
    name: 'Catalogo',
    data() {
      return{
        rutas:[
          {
            name:'ventas',
            tittle: 'Ventas'
          },
          {
            name:'compras',
            tittle: 'Compras'
          },
          {
            name:'marcas',
            tittle: 'Marcas'
          },
          {
            name:'modelos',
            tittle: 'Modelos'
          },
          {
            name:'productos',
            tittle: 'Producto'
          },
          {
            name:'proveedores',
            tittle: 'Proveedores'
          },
          {
            name:'servicios',
            tittle: 'Servicios'
          },
          {
            name:'sucursal',
            tittle: 'Sucursales'
          },
          {
            name:'usuarios',
            tittle: 'Usuario'
          },
          {
            name:'empleados',
            tittle: 'Empleados'
          },
        ]
      }
    },
    components: {
      //
    },
    methods:{
      
    }
}
</script>